<div class="wrapper">
  <div class="feature-box">
    <h3>{{ title }}</h3>
    <h4>{{ message }}</h4>
    <div class="image-preview" [ngClass]="imageClass"></div>
    <button mat-flat-button color="primary" (click)="contactSales()">{{ buttonText }}</button>
  </div>
</div>
